import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import { Navigate, Outlet } from 'react-router-dom';

// render - login
const Login = Loadable(lazy(() => import('pages/Login')));
const AuthLayout = Loadable(lazy(() => import('layout/AuthLayout')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = (isLoggedIn) => ({
  path: '/',
  element: !isLoggedIn ? (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  ) : (
    <Navigate to="/" />
  ),
  children: [
    {
      path: 'login',
      element: <Login />
    }
  ]
});

export default LoginRoutes;
